var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefitIconMobile2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8384_14143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57979 19.6637H1.18457V1.07178H20.3013V4.66562V19.6637H12.7623",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.964 11.9425H12.3176V14.5935H9.17293V11.9425H6.51758V8.79349H9.17293V6.14258H12.3176V8.79349H14.964V11.9425Z",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4657 19.6641H20.3018",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6388 19.6637H37.4611V13.6369C37.4611 12.9474 37.1808 12.3247 36.7272 11.8666C36.269 11.4174 35.6463 11.1327 34.9569 11.1327C33.8272 11.1327 32.8442 10.381 32.5418 9.29132L31.7812 6.50253C31.4787 5.41726 30.4958 4.66113 29.366 4.66113H20.2969",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67554 26.647C11.9822 26.647 13.852 24.7771 13.852 22.4705C13.852 20.1638 11.9822 18.2939 9.67554 18.2939C7.36891 18.2939 5.49902 20.1638 5.49902 22.4705C5.49902 24.7771 7.36891 26.647 9.67554 26.647Z",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6418 22.4703C11.6418 23.5556 10.7612 24.4363 9.6759 24.4363C8.59063 24.4363 7.70996 23.5556 7.70996 22.4703C7.70996 21.3851 8.59063 20.5044 9.6759 20.5044C10.7612 20.5044 11.6418 21.3851 11.6418 22.4703Z",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5505 26.647C30.8572 26.647 32.727 24.7771 32.727 22.4705C32.727 20.1638 30.8572 18.2939 28.5505 18.2939C26.2439 18.2939 24.374 20.1638 24.374 22.4705C24.374 24.7771 26.2439 26.647 28.5505 26.647Z",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5178 22.4703C30.5178 23.5556 29.6371 24.4363 28.5519 24.4363C27.4666 24.4363 26.5859 23.5556 26.5859 22.4703C26.5859 21.3851 27.4666 20.5044 28.5519 20.5044C29.6371 20.5044 30.5178 21.3851 30.5178 22.4703Z",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.461 19.6641H38.0748C38.4573 19.6641 38.8131 19.8197 39.0667 20.0733C39.3202 20.3268 39.4759 20.6826 39.4759 21.0651C39.4759 21.8391 38.8487 22.4662 38.0748 22.4662H32.7285",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3751 22.4663H13.8516",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18457 19.6641C1.18457 21.2164 2.44331 22.4662 3.9867 22.4662H5.49007",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3789 4.66533V2.53037C23.3789 1.37393 24.3085 0.444336 25.4649 0.444336C26.0387 0.444336 26.568 0.675623 26.9416 1.05369C27.3197 1.43175 27.551 1.9566 27.551 2.53037V4.66533",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3789 4.66553L23.7926 8.18821C23.9393 9.4336 24.9935 10.3676 26.2433 10.3676H33.1552",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4615 14.5933H20.3018",
    stroke: "#187C85",
    strokeWidth: 0.85983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8384_14143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.1809,
    height: 27.0917,
    fill: "white",
    transform: "translate(0.739258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIconMobile2);
export default __webpack_public_path__ + "static/media/benefit-icon-mobile2.063d62fb8fc72029b2b1e63decff53fe.svg";
export { ForwardRef as ReactComponent };